import { render, staticRenderFns } from "./benzm.vue?vue&type=template&id=51156646"
import script from "./benzm.vue?vue&type=script&lang=js"
export * from "./benzm.vue?vue&type=script&lang=js"
import style0 from "./benzm.vue?vue&type=style&index=0&id=51156646&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports